function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MexicoFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2344",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2344)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.5 3H24V21H16.5V3Z",
      fill: "#D9071E"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3H9V21H0V3Z",
      fill: "#006923"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 3H16.5V21H7.5V3Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.7881 8.93503C10.7881 8.93503 10.273 9.33452 10.3694 9.76043C10.4657 10.1863 11.4808 9.76043 11.3581 9.34773C11.2354 8.93503 10.7881 8.93503 10.7881 8.93503Z",
      fill: "#FCCA3D"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.0016 9.95106C9.61615 9.95106 9.45547 9.62988 9.53519 9.28851C9.5778 9.10608 9.68845 8.87465 9.869 8.57394L10.512 8.96002C10.4432 9.07467 10.3883 9.17419 10.3476 9.25633C10.4824 9.29615 10.6153 9.3553 10.7234 9.42652C11.0736 9.65712 11.2025 10.068 10.8271 10.3725C10.7544 10.4315 10.6365 10.6324 10.5714 10.8254C10.7506 10.8353 10.8786 10.8623 10.9966 10.9321C11.3281 11.1282 11.297 11.4858 11.0445 11.762C10.8656 11.9577 10.6267 12.1165 10.4016 12.1978C10.0272 12.3331 9.62656 12.2813 9.62656 11.8019L9.62647 11.7984C9.62573 11.7789 9.62447 11.7455 9.79169 11.7417C9.50637 11.7377 9.4453 11.5866 9.40972 11.3177C9.4007 11.2495 9.39707 11.1847 9.39206 11.0448L9.38873 10.9537L9.38471 10.865L9.38351 10.8453C9.37787 10.7587 9.37397 10.6988 9.56805 10.6988H9.133V9.94876H9.56805C9.8148 9.94876 9.95116 10.0321 10.0293 10.2043C10.0728 10.1262 10.1201 10.0527 10.1699 9.98675C10.1072 9.96504 10.0436 9.95106 10.0016 9.95106ZM10.4793 11.2684L10.4909 11.2559C10.4897 11.2573 10.4884 11.2591 10.4872 11.2612L10.4793 11.2684ZM10.1507 11.491C10.1505 11.491 10.151 11.491 10.1518 11.4908L10.1507 11.491ZM10.1517 11.2081L10.1532 11.2193C10.1524 11.2128 10.1516 11.2056 10.1508 11.1976L10.1517 11.2081ZM9.7917 11.7417C9.79411 11.7417 9.79655 11.7416 9.79903 11.7416ZM9.82427 11.7414C9.81547 11.7414 9.80706 11.7414 9.79903 11.7416L9.81287 11.7413L9.82427 11.7414Z",
      fill: "#A8AC71"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.4499 12.3021C14.4499 12.3021 15.1436 10.2461 14.0408 9.18185C12.938 8.11758 11.6637 8.18879 11.6637 8.18879C11.6637 8.18879 11.2967 8.46145 11.6637 8.66939C12.0307 8.87734 11.8769 9.07672 11.8769 9.07672C11.8769 9.07672 11.2624 8.45269 10.8544 8.81727C10.4464 9.18185 11.2352 9.12637 11.1517 9.40088C11.0682 9.6754 10.7144 10.8942 11.2314 11.5095C11.7483 12.1249 10.7426 11.9913 10.9472 11.9913C11.1517 11.9913 11.8769 12.1345 11.8769 11.9913C11.8769 11.8481 12.1291 12.5482 12.3448 12.5482C12.5606 12.5482 12.7271 12.3021 12.7271 12.3021C12.7271 12.3021 13.0296 12.5482 13.2139 12.5482C13.3982 12.5482 14.0408 12.3872 14.0408 12.3872L12.8262 11.3638C12.8262 11.3638 12.8994 10.9124 12.7271 10.8147C12.5548 10.717 14.1085 11.6805 14.2301 11.9913C14.3518 12.3021 14.4499 12.3021 14.4499 12.3021Z",
      fill: "#8F4620"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.29987 11.7949C8.29987 11.7949 8.41248 11.436 8.53305 11.4111C8.6375 11.3895 8.85715 11.5831 8.85715 11.5831C9.24733 13.7505 10.1908 14.597 11.7562 14.597C13.3401 14.597 14.3 13.9538 14.8602 11.9548C14.8602 11.9548 15.158 11.6507 15.2631 11.6845C15.3775 11.7213 15.5208 12.1237 15.5208 12.1237C15.3775 14.4612 13.6899 15.8467 11.7822 15.8467C9.85602 15.8467 8.28333 14.2942 8.29987 11.7949Z",
      fill: "#9FAB2F"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.0007 13.2423C10.0007 13.2423 12.2539 13.7203 13.1433 13.7203C14.0327 13.7203 12.363 14.4461 11.7115 14.4461C11.06 14.4461 10.0007 13.2423 10.0007 13.2423Z",
      fill: "#2FC2DC"
    }), /*#__PURE__*/_jsx("rect", {
      x: "11.0001",
      y: "13.575",
      width: "1.5",
      height: "0.803572",
      rx: "0.0833333",
      fill: "#F9AA51"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.13165 12.1019L9.74562 11.6712C10.5447 12.8101 11.7397 13.1848 13.411 12.7937L13.5819 13.524C11.6281 13.9812 10.1179 13.5076 9.13165 12.1019Z",
      fill: "#259485"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.4436 12.2627C12.4436 12.2627 11.5333 12.7418 11.8367 12.7418C12.1401 12.7418 13.3276 12.9814 13.0965 12.7418C12.8655 12.5022 12.4436 12.2627 12.4436 12.2627Z",
      fill: "#FCCA3D"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.3673 11.6912C11.3673 11.6912 11.1944 11.1916 10.8345 11.1916C10.4745 11.1916 10.5761 11.6014 10.4031 11.6014C10.23 11.6014 10.5643 11.8898 10.7134 11.8898C10.8624 11.8898 11.3673 11.6912 11.3673 11.6912Z",
      fill: "#FCCA3D"
    })]
  })]
}));
//# sourceMappingURL=Mexico.js.map